import Model from './Model';

/**
 * @example
 * const TrajectoryDocuments = Document.makeModel('/trajectories/13/files')
 * TrajectoryDocuments.collection() // returns all Documents of the trajectory 13
 */
export default class ReturnedDocument extends Model {
    uploader_id;
    uploader;
    date;
    mime;
    name;
}



// WEBPACK FOOTER //
// ./src/models/ReturnedDocument.js